module.exports = __webpack_public_path__ + "static/img/feature1.eed2e4f3.png";